import { node } from 'prop-types';

const propTypes = {
  element: node.isRequired,
};

const Root = ({ element }) => {
  return element;
};

Root.propTypes = propTypes;

export default Root;
